import { useStepperContext } from "../../../../context/stepper-provider";
import { useNavigate } from "react-router-dom";
import OfflineDefine from "../../../../components/define/offline-define";
import OfflinePalletConfig from "../../../../components/pallet-config/offline-pallet-config";
import OfflineLpnNo from "../../../../components/LPN-No/offline-lpn-no";
import OfflinePreShip from "../../../../components/pre-ship/offline-pre-ship";
import OfflineShipTestTruckLayout from "../../../../components/post-ship/offline-ship-test-truck-layout";
import OfflinePostShip from "../../../../components/post-ship/offline-post-ship";
import OfflineStackTestLayout from "../../../../components/post-stack/offline-stack-test-layout";
import OfflinePostStack from "../../../../components/post-stack/offline-post-stack";
import OfflineSummary from "../../../../components/summary/offline-summary";
import OfflineSynopsis from "../../../../components/synopsis/offline-synopsis";
import OfflineImages from "../../../../components/images/offline-images";

export default function NewOfflineProjectPage() {
    const { stepper } = useStepperContext();
    const navigate = useNavigate();

    const handleSuccess = (projectId: string) => {
        navigate(`/offline/projects/edit-project/${projectId}`);
    };

    return (
        <div className="container mx-auto px-4 py-8">
            {stepper.when("1", () => (
                <OfflineDefine isOffline={true} onSuccess={handleSuccess} />
            ))}
            {stepper.when("2", () => (
                <OfflinePalletConfig isOffline={true} />
            ))}
            {stepper.when("3", () => (
                <OfflineLpnNo isOffline={true} />
            ))}
            {stepper.when("4", () => (
                <OfflinePreShip isOffline={true} projectId={''} />
            ))}
            {stepper.when("5", () => (
                <OfflineShipTestTruckLayout isOffline={true} projectId={''} />
            ))}
            {stepper.when("6", () => (
                <OfflinePostShip isOffline={true} projectId={''} />
            ))}
            {stepper.when("7", () => (
                <OfflineStackTestLayout isOffline={true} projectId={''} />
            ))}
            {stepper.when("8", () => (
                <OfflinePostStack isOffline={true} projectId={''} />
            ))}
            {stepper.when("9", () => (
                <OfflineSummary isOffline={true} projectId={''} />
            ))}
            {stepper.when("10", () => (
                <OfflineSynopsis isOffline={true} projectId={''} />
            ))}
            {stepper.when("11", () => (
                <OfflineImages isOffline={true} projectId={''} />
            ))}
        </div>
    );
} 